import CarrotClient from "../../lib/carrot-api"
import Settings from "../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { AdminUser } from "types/Admin"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetAdminUser"

export default function useAdminUser(): UseQueryResult<AdminUser, ResponseError> {
  return useQuery<AdminUser, ResponseError>([ENDPOINT], () => client.getAdminUser(), {
    ...RetryConfig
  })
}
